import { useState, useEffect } from 'react';
import { CgMenuGridO } from "react-icons/cg";
import { MdArrowBackIosNew } from "react-icons/md";

export default function Header() {
  const [activeLink, setActiveLink] = useState('About Me');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup function to remove event listener
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function previewTemp(id) {
    const navLinks = document.querySelectorAll('.nav-link');
    navLinks.forEach(link => {
      if (link.innerText === id) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
    setActiveLink(id);
  }

  function showSideBar() {
    document.getElementsByClassName('right-nav')[0].style.setProperty("display", "block");
  }

  function hideSideBar() {
    document.getElementsByClassName('right-nav')[0].style.setProperty("display", "none");
  }

  return (
    <header
      className={`w-full fixed z-50 top-0 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'
        }`}
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center px-6 py-4 md:py-8">
        <h1 className="brand-name text-crimson text-3xl font-bold">
          <a href="#home">Amelia.</a>
        </h1>
        <CgMenuGridO
          className="menu hidden hover:bg-[nudeBlush] hover:shadow-hoverInactive max-[450px]:block absolute right-10 mt-1 p-[3.5px] shadow-default bg-paper text-center rounded text-active text-3xl"
          onClick={showSideBar}
        />
        <div className="inline-block">
          <nav className="navbar">
            <ul className="flex gap-5 right-nav">
              <MdArrowBackIosNew
                className='return absolute top-4 left-4 p-[3.5px] rounded-lg bg-[#e0218a] shadow-md shadow-paper text-3xl hidden hover:bg-[#ff98d1] text-active'
                onClick={hideSideBar}
              />
              <li className="nav-item nav-list">
                <a
                  className={`nav-link ${activeLink === 'Home' ? 'active' : 'inactive'} transition-all duration-200 hover:text-white md:hover:text-crimson hover:underline hover:italic focus:text-white md:focus:text-crimson focus:underline focus:italic`}
                  onClick={() => previewTemp('Home')}
                  href="#home"
                >
                  Home
                </a>
              </li>
              <li className="nav-item nav-list">
                <a
                  className={`nav-link ${activeLink === 'About Me' ? 'active' : 'inactive'} transition-all duration-200 hover:text-white md:hover:text-crimson hover:underline hover:italic focus:text-white md:focus:text-crimson focus:underline focus:italic`}
                  onClick={() => previewTemp('About Me')}
                  href="#testimonials"
                >
                  About Me
                </a>
              </li>
              <li className="nav-item nav-list">
                <a
                  className={`nav-link ${activeLink === 'Experience' ? 'active' : 'inactive'} transition-all duration-200 hover:text-white md:hover:text-crimson hover:underline hover:italic focus:text-white md:focus:text-crimson focus:underline focus:italic`}
                  onClick={() => previewTemp('Experience')}
                  href="#experience"
                >
                  Experience
                </a>
              </li>
              <li className="nav-item nav-list">
                <a
                  className={`nav-link ${activeLink === 'Portfolio' ? 'active' : 'inactive'} transition-all duration-200 hover:text-white md:hover:text-crimson hover:underline hover:italic focus:text-white md:focus:text-crimson focus:underline focus:italic`}
                  onClick={() => previewTemp('Portfolio')}
                  href="#portfolio"
                >
                  Portfolio
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}